__webpack_require__.p = "/disney-character-hub/";